export class NotEnoughPermissionsError extends Error {
  constructor() {
    super('User has not enough permission to do this action');
    Object.setPrototypeOf(this, NotEnoughPermissionsError.prototype);
  }
}
